// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDrrregbookIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDrrregbookIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDrrregbookIconOutlined = function DrrpDrrregbookIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDrrregbookIconOutlinedSvg
  }));
};

DrrpDrrregbookIconOutlined.displayName = 'DrrpDrrregbookIconOutlined';
export default React.forwardRef(DrrpDrrregbookIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDrrregbookIconOutlined.js
// module id = 2564
// module chunks = 0